import React, { useState } from "react";

export default function App() {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState("");

  async function getWeather(e) {
    e.preventDefault();
    setError("");
    setWeather(null);

    const apiKey = '29b1fdd3201b8b2ccaa79baa7757a51b';
    if (!city) {
      setError("لطفاً نام شهر را وارد کنید");
      return;
    }

    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric&lang=fa`
      );
      if (!res.ok) throw new Error("شهر پیدا نشد");
      const data = await res.json();
      setWeather({
        name: data.name,
        temp: data.main.temp,
        desc: data.weather[0].description,
        icon: data.weather[0].icon,
      });
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        textAlign: "center",
        marginTop: "60px",
      }}
    >
      <h1>وضعیت آب‌وهوا 🌤️</h1>
      <form onSubmit={getWeather}>
        <input
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="نام شهر را وارد کنید"
          style={{ padding: "8px", borderRadius: "6px" }}
        />
        <button type="submit" style={{ marginLeft: "8px", padding: "8px" }}>
          جستجو
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {weather && (
        <div style={{ marginTop: "20px" }}>
          <h2>
            {weather.name} — {Math.round(weather.temp)}°C
          </h2>
          <p>{weather.desc}</p>
          <img
            src={`https://openweathermap.org/img/wn/${weather.icon}@2x.png`}
            alt={weather.desc}
          />
        </div>
      )}
    </div>
  );
}